/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Feature,
  Feature$inboundSchema,
  Feature$Outbound,
  Feature$outboundSchema,
} from "./feature.js";

export type GetAvailableFeaturesResponse = {
  success?: true | undefined;
  data: Array<Feature>;
};

/** @internal */
export const GetAvailableFeaturesResponse$inboundSchema: z.ZodType<
  GetAvailableFeaturesResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  success: z.literal(true).default(true).optional(),
  data: z.array(Feature$inboundSchema),
});

/** @internal */
export type GetAvailableFeaturesResponse$Outbound = {
  success: true;
  data: Array<Feature$Outbound>;
};

/** @internal */
export const GetAvailableFeaturesResponse$outboundSchema: z.ZodType<
  GetAvailableFeaturesResponse$Outbound,
  z.ZodTypeDef,
  GetAvailableFeaturesResponse
> = z.object({
  success: z.literal(true).default(true as const),
  data: z.array(Feature$outboundSchema),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetAvailableFeaturesResponse$ {
  /** @deprecated use `GetAvailableFeaturesResponse$inboundSchema` instead. */
  export const inboundSchema = GetAvailableFeaturesResponse$inboundSchema;
  /** @deprecated use `GetAvailableFeaturesResponse$outboundSchema` instead. */
  export const outboundSchema = GetAvailableFeaturesResponse$outboundSchema;
  /** @deprecated use `GetAvailableFeaturesResponse$Outbound` instead. */
  export type Outbound = GetAvailableFeaturesResponse$Outbound;
}

export function getAvailableFeaturesResponseToJSON(
  getAvailableFeaturesResponse: GetAvailableFeaturesResponse,
): string {
  return JSON.stringify(
    GetAvailableFeaturesResponse$outboundSchema.parse(
      getAvailableFeaturesResponse,
    ),
  );
}

export function getAvailableFeaturesResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetAvailableFeaturesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetAvailableFeaturesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetAvailableFeaturesResponse' from JSON`,
  );
}
